import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'TAX_REFUND',
    icon: 'menu-tax-refund',
    label: '车辆退税',
    path: '/tax-refund',
  },
] satisfies Menu[];
